
// src\themes\tolica\elements\footer\Footer.tsx
import { getFooterItems } from '@/core/lib/api/main/menu-api';
import FooterList from './FooterList';
import Newsletter from './Newsletter';
import SocialMedia from './SocialMedia';
import Image from 'next/image';
import Link from 'next/link';
import { getSettings } from '@/core/lib/api/main/setting';
import { getDictionaryServer } from '@/core/lib/dictionary';

export default async function Footer() {
  const footerItems = await getFooterItems();
  const setting = await getSettings();
  const { dictionary } = await getDictionaryServer();
  const isVanda = process.env.NEXT_PUBLIC_SITE_NAME === 'vanda';

  if (isVanda) {
    return (
      <footer className="border-t z-10 bg-[#171717] text-primary-0 mt-10">
        <div className="max-w-screen-xl mx-auto px-6 py-10">
          {/* بخش لوگو + اطلاعات شرکت + سوشال مدیا - به سبک کد دیگه */}
          <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-8 lg:gap-8">

            {/* لوگو + نماد */}
            <div className="flex flex-row lg:flex-col items-center lg:items-end gap-4 shrink-0">
              {setting.logo_footer && (
                <Image
                  src={setting.logo_footer}
                  alt={setting.site_title || 'Logo'}
                  width={170}
                  height={80}
                  className="object-contain"
                />
              )}
              {setting.enamad && (
                <div
                  className="size-14"
                  dangerouslySetInnerHTML={{ __html: setting.enamad }}
                />
              )}
            </div>

            {/* آدرس / تماس / شبکه اجتماعی */}
            <div className="flex flex-col gap-2 shrink-0 lg:w-56">
              {setting.factory_address && (
                <p className="text-xs text-primary-200 leading-5">
                  {dictionary.forms.factoryAddress} : {setting.factory_address}
                </p>
              )}
              {setting.after_sales_phone && (
                <p className="text-xs text-primary-200">
                  {dictionary.forms.afterSales} : {setting.after_sales_phone}
                </p>
              )}
              <SocialMedia iconColor="#fff" />
            </div>

            {/* ستون‌های منو */}
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-10 gap-y-8 flex-1">
              {footerItems.map((item) => (
                <div key={item.id} className="space-y-4">
                  <h4 className="text-sm font-primary-bold text-primary-0">
                    {item.title}
                  </h4>
                  <ul className="space-y-3">
                    {item.children?.map((child) => (
                      <li key={child.id}>
                        <Link
                          href={child.link}
                          className="text-sm text-primary-200 hover:text-primary-0 transition-colors"
                        >
                          {child.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer className='pt-10 border-t z-10 flex flex-col border-primary-600 bg-primary-0  mt-10'>
      <div className="flex flex-col lg:flex-row gap-8 pb-5">
        <div className="flex w-full lg:w-2/3 flex-col sm:flex-row justify-between p-4 gap-8 ">
          <div className="flex flex-col lg:flex-row gap-8 items-start">
            {setting.logo_footer && (
              <Image
                src={setting.logo_footer}
                alt={setting.site_title || "Logo"}
                width={180}
                height={80}
                className="object-contain"
              />
            )}
          </div>
          <FooterList footerItems={footerItems} />
        </div>
        <div className='border border-primary-100 m-4'></div>
        <div className="w-full lg:w-1/3 p-4 flex flex-col justify-between gap-6">
          <Newsletter />
          <SocialMedia iconColor="#000" />
        </div>
      </div>

      {setting.enamad && (
        <div className='border-t border-primary-900 bg-primary-200 p-4'>
          <div
            className='size-16'
            dangerouslySetInnerHTML={{ __html: setting.enamad }}
          />
        </div>
      )}
    </footer>
  );
}